
export const useLoanCalculatorConstants = () => {
  return {
    min_loan_value: window?.static_data?.minimum_loan_value,
    max_loan_value: window?.static_data?.maximum_loan_value,
    loan_value_step: window?.static_data?.loan_value_step,
    default_loan_value: window?.static_data?.default_loan_value,
    default_loan_tenure: window?.static_data?.default_loan_tenure,
    loan_tenures: window?.static_data?.loan_tenures,
    loan_tenures_step: Number(window.static_data.loan_tenures[1])
    - Number(window.static_data.loan_tenures[0]),
    loan_tenures_min: Number(window.static_data.loan_tenures[0]),
    loan_tenures_max: Number(
      window.static_data.loan_tenures[window.static_data.loan_tenures.length - 1]
    ),
    representative_example_amount: window?.static_data?.representative_example_amount,
    representative_example_months: window?.static_data?.representative_example_months,
    representative_example_nominal_rate:
        window?.static_data?.representative_example_nominal_rate,
    representative_example_apr: window?.static_data?.representative_example_apr,
    representative_example_total_to_repay:
      window?.static_data?.representative_example_total_to_repay,
    representative_example_interest_amount:
      window?.static_data?.representative_example_interest_amount,
    representative_example_regular_repayment_amount:
      window?.static_data?.representative_example_regular_repayment_amount,
    representative_example_final_repayment_amount:
      window?.static_data?.representative_example_final_repayment_amount,
  };
};
